import { Building2, Shield, CheckCircle, FileText } from 'lucide-react'

export const companyRegistrationSteps = [
    {
        id: 1,
        title: 'Company Details',
        description: 'Basic information & verification',
        icon: Building2,
        color: 'from-blue-500 to-cyan-500',
        route: '/company/registration/legal-details'
    },
    {
        id: 2,
        title: 'Profile Building',
        description: 'Company profile and branding',
        icon: Shield,
        color: 'from-purple-500 to-violet-500',
        route: '/company/registration/profile'
    },
    {
        id: 3,
        title: 'Subscription',
        description: 'Choose your plan & payment',
        icon: CheckCircle,
        color: 'from-orange-500 to-red-500',
        route: '/company/registration/subscription'
    },
    {
        id: 4,
        title: 'Documents',
        description: 'Upload legal documents',
        icon: FileText,
        color: 'from-green-500 to-emerald-500',
        route: '/company/registration/documents'
    }
]
